import Vue from 'vue'
import Vuex from 'vuex'
import Router from 'vue-router'
// import moment from "moment";
//
// Vue.prototype.$moment = moment;
// import * as path from "path";

Vue.use(Vuex)
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this,location).catch(err => err)
}

const Login = () => import('../views/login/Login')
const Index = () => import('../views/main/Index')
const Register = () => import('../views/register/Register')
const WechatLogin = () => import('../views/wechat/WechatLogin')

const Video = () => import('../views/product/Video')

const Test = () => import('../views/chart/Test.vue')

import UpdatePassword from '../views/login/UpdatePassword'
import Order from '../views/order/OrderList'
import OrderProduct from '../views/orderproduct/OrderProduct'


import Product from '../views/product/ProductList'
import WebSocketTest from '../views/product/WebSocketTest'

import Address from '../views/address/AddressList'
import User from '../views/user/UserList'
import Role from '../views/user/Role'

const routes = [
    {
        path: '/',
        redirect: '/login',
        hidden: true
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        // hidden: true
    },
    {
        path: '/register',
        name: 'Register',
        component: Register,
        hidden: true
    },
    {
        path: '/wechat/login',
        name: 'WechatLogin',
        component: WechatLogin,
        hidden: true
    },
    {
        path: '/test',
        name: 'Test',
        component: Test,
        hidden: true
    },
    {
        path: '/video',
        name: 'video',
        component: Video,
        hidden: true
    },
    {
        path: '/updatePassword',
        name: 'UpdatePassword',
        component: UpdatePassword,
        hidden: true
    },
    {
        path: '/index',
        name: '首页',
        component: Index
    },
    {
        path: '/index',
        name: '订单管理',
        component: Index,
        children: [
            {
                path: '/order',
                name: '订单列表',
                component: Order
            },
            {
                path: '/orderproduct',
                name: '订单商品',
                component: OrderProduct
            },
        ],
    },
    {
        path: '/index',
        name: '产品管理',
        component: Index,
        children: [
            {
                path: '/product',
                name: '产品列表',
                component: Product
            },
            {
                path: '/websocket',
                name: 'websocket-测试',
                component: WebSocketTest
            },
        ]
    },

    {
        path: '/index',
        name: '地址管理',
        component: Index,
        children: [
            {
                path: '/address',
                name: '地址列表',
                component: Address
            },
        ],
    },
    {
        path: '/index',
        name: '账号管理',
        component: Index,
        children: [
            {
                path: '/user',
                name: '账号列表',
                component: User
            },
            {
                path: '/role',
                name: '角色列表',
                component: Role
            },
        ],
    },

]

// 将路径注入到Router中
const router = new Router({
    'mode': 'history',
     routes
})
// 导出路由
export default router;
